import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link, withRouter } from 'react-router';
import ShowCampaigns from '../components/campaigns/ShowCampaigns';
import { clearAuthErrors, fetchCampaigns, disableCampaign, clearCampaignsErrors } from '../actions';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  campaigns: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class CampaignsPage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  // TODO: review this, why duplication on each Container - gabo
  getChildContext() {
    return {
      muiTheme: getMuiTheme(baseTheme),
    };
  }
  componentWillMount() {
    this.props.dispatch(clearCampaignsErrors());
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    const query = this.props.query;
    const router = this.props.router;
    if (this.props.campaigns.search && this.props.campaigns.search.length > 0) {
      query.search = this.props.campaigns.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/campaigns', query });
    } else {
      this.props.dispatch(fetchCampaigns(query));
    }
  }
  onCampaignDisable(data) {
    this.props.dispatch(disableCampaign(data));
    this.props.dispatch(fetchCampaigns(this.props.query));
  }
  handleSearchChange(e) {
    const campaigns = this.props.campaigns;
    const query = this.props.query;
    const router = this.props.router;
    const nextName = e.target.value;
    campaigns.search = nextName;
    this.setState({
      campaigns,
    });
    if (nextName.length > 0) {
      query.search = nextName;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/campaigns', query });
    this.props.dispatch(fetchCampaigns(query));
  }
  navigation(route) {
    // add search to url
    this.props.dispatch(fetchCampaigns(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="campaign component" style={authPage}>
        <h2>Campaigns</h2>
        <div className="content">
          <div className="action-buttons">
            <Link to={'/campaigns/new'}>
              <RaisedButton
                label="Add New Campaign"
                primary
              />
            </Link>
          </div>
          <div className="action-buttons top">
            <TextField
              floatingLabelText="Search by Name/Email"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.campaigns.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.campaigns.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowCampaigns
            campaigns={this.props.campaigns}
            onCampaignDisable={data => this.onCampaignDisable(data)}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.campaigns.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

CampaignsPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CampaignsPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    campaigns: state.campaigns,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(CampaignsPage));



// WEBPACK FOOTER //
// ./src/containers/CampaignsPage.js